import React from 'react';
import { Users, Clock, DollarSign, MapPin } from 'lucide-react';
import { Camp } from '../../../utils/types';
import { CampFormatUtils } from '../../../utils/campFormatUtils';
import './CampKeyInfo.css';

interface CampKeyInfoProps {
  camp: Camp;
  className?: string;
}

const CampKeyInfo: React.FC<CampKeyInfoProps> = ({ camp, className = '' }) => {
  const getLocationString = () => {
    const parts = [camp.street_address, camp.city, camp.state].filter(Boolean);
    return parts.length > 0 ? parts.join(', ') : 'Location information not available';
  };

  return (
    <div className={`camp-key-info ${className}`}>
      <div className="camp-key-info-item">
        <Users className="icon icon--sm" />
        <span className="camp-key-info-text">Ages: {CampFormatUtils.formatAgeRange(camp.min_age, camp.max_age)}</span>
      </div>

      <div className="camp-key-info-item">
        <Clock className="icon icon--sm" />
        <span className="camp-key-info-text">
          Hours: {CampFormatUtils.formatTimeRange(camp.start_time, camp.end_time)}
        </span>
      </div>

      <div className="camp-key-info-item">
        <DollarSign className="icon icon--sm" />
        <span className="camp-key-info-text">Price: {CampFormatUtils.getPriceDisplay(camp)}</span>
      </div>

      <div className="camp-key-info-item">
        <MapPin className="icon icon--sm" />
        <span className="camp-key-info-text">Location: {getLocationString()}</span>
      </div>
    </div>
  );
};

export default CampKeyInfo;
